import { createContext } from "react";

export const PlatformLinksContext = createContext();
